<template>
  <div>
    <ReportDetail :key="keyComp" />
  </div>
</template>

<script>
import ReportDetail from "../../components/reportDetail/index.vue";
export default {
  components: {
    ReportDetail,
  },
  data(){
    return {
      keyComp: 1
    }
  },
  watch: {
    '$route'(){
      this.keyComp ++;
    },
  }
};
</script>

<style>
</style>